import { Link } from "react-router-dom";
import { ArrowRight, Tv, Hammer, Dumbbell, Plug, Truck, Frame, TreePine, Wrench, Gamepad2 } from "lucide-react";
import { placeholderSvg } from "../lib/placeholder";

const ICONS = { Tv, Hammer, Dumbbell, Plug, Truck, Frame, TreePine, Wrench, Gamepad2 };

export default function ServiceCard({ service, withImage = true }) {
  const Icon = ICONS[service.icon] || Hammer;
  return (
    <div
      data-testid={`service-card-${service.slug}`}
      className="card-elevate bg-white border border-border rounded-2xl overflow-hidden flex flex-col"
    >
      {withImage && (
        <div className="aspect-[16/10] overflow-hidden bg-secondary">
          <img
            src={service.image}
            alt={service.title}
            loading="lazy"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = placeholderSvg(service.fallbackLabel || service.title); }}
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>
      )}
      <div className="p-6 sm:p-7 flex flex-col flex-1">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-secondary text-primary">
          <Icon size={20} />
        </span>
        <h3 className="mt-4 text-xl font-bold text-primary">{service.title}</h3>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{service.short}</p>
        <ul className="mt-4 space-y-1.5 text-sm text-primary/80">
          {service.bullets.map((b) => (
            <li key={b} className="flex items-start gap-2">
              <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-accent shrink-0" />
              {b}
            </li>
          ))}
        </ul>
        <Link
          to="/contact"
          data-testid={`service-cta-${service.slug}`}
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-accent transition-colors group"
        >
          Get a free estimate
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>
  );
}
